var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"code-snippet"},[_c('div',{staticClass:"language"},[_vm._v(_vm._s(_vm.lang))]),_c('div',{staticClass:"line-numbers"},_vm._l((_vm.lineCount),function(n){return _c('div',{key:n,staticClass:"line-number"},[_vm._v(_vm._s(n))])}),0),_c('div',{staticClass:"render",domProps:{"innerHTML":_vm._s(_vm.result)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }